/**
 * /dashboard/expenses — Expense Tracking hub, "My expenses" view
 * (SOP §1.2; Phase 3d — 2026-06-01).
 *
 * Migration note: port of
 * frontend/src/app/(dashboard)/dashboard/expenses/page.tsx flattened
 * with the old `layout.tsx` into one route that uses ExpensesModuleShell.
 * Legacy `?tab=` redirect helper is dropped — TanStack typed routes
 * are the only entry point.
 */

import { createFileRoute, Link , useParams} from "@tanstack/react-router";
import { Receipt } from "lucide-react";
import { ExpensesModuleShell } from "@/components/shared/expenses-module-shell";
import { ExpenseFeatureGate } from "@/components/expenses/expense-feature-gate";
import { ExpensesTab } from "@/components/expenses/expenses-tab";
import { useExpenseRoles } from "@/components/expenses/use-expense-roles";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/expenses/")({
  component: ExpensesHubRoute,
});

function ExpensesHubRoute() {
  const { tenantSlug } = useParams({ strict: false }) as { tenantSlug: string };
  const { isApprover } = useExpenseRoles();
  return (
    <ExpensesModuleShell
      title="Expenses"
      description={
        isApprover
          ? "Review and act on expense claims, and manage your own."
          : "File expense claims and track reimbursement."
      }
      actions={
        <Button asChild className="gap-1.5">
          <Link to="/app/$tenantSlug/expenses/new" params={{ tenantSlug }}>
            <Receipt className="h-4 w-4" />
            New expense
          </Link>
        </Button>
      }
    >
      <ExpenseFeatureGate>
        <ExpensesTab />
      </ExpenseFeatureGate>
    </ExpensesModuleShell>
  );
}
